import { type EdgeProps } from '@xyflow/react';
import { Tag } from 'antd';

import CustomEdgeBase from '../CustomEdgeBase';

export default function IfEdge(props: EdgeProps) {
  return <CustomEdgeBase edgeProps={props} centerContent={<Tag bordered>Is True</Tag>} hideAddNode />;
}
